import * as records from "data/records";
import _ from "lodash";
import moment from "moment";
import { request } from "./request";

// I'd like an APIv3 search endpoint, but for now we're gonna bodge things
// with the APIv2 search endpoint

// global endpoint that all searches go through
const ENDPOINT = "/find/search";

// function to munge keys so that Rails will play nice
const searchKeys = (object) => _.mapKeys(object, (v, k) => `search[${_.snakeCase(k)}]`);

export const search = ({
  types,
  length,
  elevation,
  movingTime,
  avgSpeed,
  avgWatts,
  rideDate,
  createdOn,
  updatedOn,
  privacy,
  radius,
  hasCuesheet,
  ...rest
}) => {
  const typeOptions = {
    trips: types.includes("trips") ? true : undefined,
    routes: types.includes("routes") ? true : undefined,
    segments: types.includes("segments") ? true : undefined,
    excludeTrips: types.includes("trips") ? undefined : true,
    excludeRoutes: types.includes("routes") ? undefined : true,
  };
  const privacyOptions = {
    privacyPublic: privacy && privacy.includes("public") ? true : undefined,
    privacyFriendsOnly: privacy && privacy.includes("friendsOnly") ? true : undefined,
    privacyPrivate: privacy && privacy.includes("private") ? true : undefined,
  };
  const lengthOptions = length ? { length_min: length.min, length_max: length.max } : {};
  const elevationOptions = elevation ? { elevation_min: elevation.min, elevation_max: elevation.max } : {};
  const movingTimeOptions = movingTime
    ? {
        moving_time_min: movingTime.min ? movingTime.min * 3600 : undefined,
        moving_time_max: movingTime.max ? movingTime.max * 3600 : undefined,
      }
    : {};
  const avgSpeedOptions = avgSpeed ? { avg_speed_min: avgSpeed.min, avg_speed_max: avgSpeed.max } : {};
  const avgWattsOptions = avgWatts ? { avg_watts_min: avgWatts.min, avg_watts_max: avgWatts.max } : {};
  const rideDateOptions = rideDate
    ? {
        departed_at_min: rideDate.min && moment(rideDate.min).toISOString(),
        departed_at_max: rideDate.max && moment(rideDate.max).endOf("day").toISOString(),
      }
    : {};
  const createdOnOptions = createdOn
    ? {
        created_min: createdOn.min && moment(createdOn.min).toISOString(),
        created_max: createdOn.max && moment(createdOn.max).endOf("day").toISOString(),
      }
    : {};
  const updatedOnOptions = updatedOn
    ? {
        updated_min: updatedOn.min && moment(updatedOn.min).toISOString(),
        updated_max: updatedOn.max && moment(updatedOn.max).endOf("day").toISOString(),
      }
    : {};
  const radiusOptions = radius ? { start_distance: radius } : {};
  const hasCuesheetOptions = hasCuesheet ? { has_course_points: true } : {};

  const params = {
    ...typeOptions,
    ...privacyOptions,
    ...lengthOptions,
    ...elevationOptions,
    ...movingTimeOptions,
    ...avgSpeedOptions,
    ...avgWattsOptions,
    ...rideDateOptions,
    ...radiusOptions,
    ...createdOnOptions,
    ...updatedOnOptions,
    ...hasCuesheetOptions,
    ...rest,
  };

  const deserializeByType = (searchResult) => {
    const { type } = searchResult;
    const serializedObj = searchResult[type];
    const recordName = _.capitalize(_.camelCase(type));
    if (records[recordName]) {
      return records[recordName].deserialize(serializedObj);
    } else {
      console.warn(`no deserializer found for search result type '${type}', omitting from search results`);
      return null;
    }
  };

  const deserialize = (results) => results.map(deserializeByType).filter((r) => r !== null);

  return request.get(ENDPOINT, { params: searchKeys(params) }).then(({ results, ...rest }) => ({
    results: deserialize(results),
    rawResults: results,
    params,
    ...rest,
  }));
};
